var map = {
	"./aberto.png": 9549,
	"./cintura.png": 7148,
	"./normal.png": 7611,
	"./pensativo.png": 9477,
	"./pensativo2.png": 547,
	"./um.png": 40,
	"./unhas.png": 3267
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 8539;